import { useAtomValue } from "jotai";
import { NavLink } from "react-router-dom";

import { tv } from "@/lib/tailwind-variants";
import { sidebarCollapsedAtom } from "@/stores/layout";

type Props = {
  label: string;
  href: string;
  icon?: React.ReactNode;
};

const sideNavItemLinkVariants = tv({
  slots: {
    base: "block rounded-l hover:text-white hover:opacity-75 focus-visible:underline focus-visible:decoration-white focus-visible:underline-offset-2",
    inner: "flex",
    text: "text-white",
  },
  variants: {
    collapsed: {
      true: {
        base: "py-2",
        inner: "flex-col items-center gap-1 pr-2",
        text: "max-w-[3em] text-center text-[10px] leading-snug wrap-break-word",
      },
      false: {
        base: "p-2",
        inner: "items-center gap-2.5",
        text: "truncate text-Medium",
      },
    },
    isActive: {
      true: {
        base: "bg-primary-600",
      },
      false: { base: "bg-transparent" },
    },
    hrefEmpty: {
      true: { base: "pointer-events-none opacity-50" },
    },
  },
  defaultVariants: {
    collapsed: false,
    isActive: false,
    hrefEmpty: false,
  },
});

export const SideNavItemLink = ({ label, icon, href }: Props) => {
  const collapsed = useAtomValue(sidebarCollapsedAtom);

  const { base, inner, text } = sideNavItemLinkVariants({ collapsed });

  return (
    <NavLink
      to={href}
      // truncateされた文字列の確認用
      title={label}
      className={({ isActive }) => base({ isActive, hrefEmpty: !href })}
    >
      <div className={inner()}>
        {icon ? <span>{icon}</span> : null}
        <span className={text()}>{label}</span>
      </div>
    </NavLink>
  );
};
